import controller from './family-plan-member-registration-dialog.controller';

export default {
  controller,
  template: require('./family-plan-member-registration-dialog.html')
};



// WEBPACK FOOTER //
// src/app/family-plan/family-plan-member-registration-dialog/family-plan-member-registration-dialog.component.ts